import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import styles from './searchActionsMenu.module.css';
import TooltipForm from "../tooltipForm";

export function SearchActionsMenu({ actionsRight, buttonIconClass, titleAction, disabled = false }) {
  const [open, setOpen] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const [menuPos, setMenuPos] = useState({ top: 0, left: 0 });
  const [submenuPos, setSubmenuPos] = useState({ top: 0, left: 0 });
  const buttonRef = useRef(null);
  const itemRefs = useRef([]);

  // Fermer le menu si clic à l’extérieur
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        buttonRef.current &&
        !buttonRef.current.contains(e.target) &&
        !document.getElementById('search-menu-portal')?.contains(e.target) &&
        !document.getElementById('submenu-portal')?.contains(e.target)
      ) {
        setOpen(false);
        setOpenSubmenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  

  // Ouvrir / fermer le menu et calculer la position
  const toggleMenu = () => {
    if (disabled) return;
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setMenuPos({
        top: rect.bottom + window.scrollY - 14,
        left: rect.left + window.scrollX
      });
      setOpen(!open);
      setOpenSubmenu(null);
    }
  };

  const openMenuOnHover = () => {
    if (disabled) return;
    if (!open && buttonRef.current) { // si le menu n’est pas déjà ouvert
      const rect = buttonRef.current.getBoundingClientRect();
      setMenuPos({
        top: rect.bottom + window.scrollY - 14,
        left: rect.left + window.scrollX
      });
      setOpen(true);
    }
    setOpenSubmenu(null);
  };

  const openSub = (idx) => {
    const item = itemRefs.current[idx];
    if (item) {
      const rect = item.getBoundingClientRect();
      setSubmenuPos({
        top: rect.top + window.scrollY - 14,
        left: rect.right + window.scrollX + 2,
      });
    }
    setOpenSubmenu(idx);
  };

  return (
    <>
      {/* Bouton principal */}
      <TooltipForm content={titleAction && titleAction.trim() !== "" ? titleAction : "Afficher les actions"}>
        <button
          ref={buttonRef}
          type="button"
          onClick={toggleMenu}
          onMouseEnter={openMenuOnHover}
          className={`${styles.butMenu} ${disabled ? styles.disabled : ""}`}
        >
        {buttonIconClass ? <i className={buttonIconClass} /> : <i className="fa-solid fa-bars" />}
        </button>
      </TooltipForm>

      {/* Menu des actions dans un portal */}
      {open &&
        ReactDOM.createPortal(
          <ul
            id="search-menu-portal"
            className={styles.winMenu}
            style={{
              position: "absolute",
              top: menuPos.top,
              left: menuPos.left,
            }}
          >
            {actionsRight.map((action, idx) => (
              <React.Fragment key={idx}>
                <li
                  ref={(el) => (itemRefs.current[idx] = el)}
                  className={styles.winItem}
                  onClick={(e) => {
                    if (action.submenu) {
                      e.stopPropagation();
                      openSub(idx);
                    } else {
                      action.onClick(e);
                      setOpen(false);
                    }
                  }}
                  onMouseEnter={() => {
                    if (action.submenu) {
                      openSub(idx);
                    } else {
                      setOpenSubmenu(null);
                    }
                  }}
                >
                  <span className={styles.winIcon}>{action.icon}</span>
                  <span className={styles.winLabel}>{action.label}</span>
                  {action.submenu && <i className="fa-solid fa-chevron-right" />}                 

                </li>
                {/* Séparateur automatique sauf après le dernier */}
                {idx < actionsRight.length - 1 && (
                  <li className={styles.winSeparator}></li>
                )}
              </React.Fragment>
            ))}
          </ul>,
          document.body
        )}
        {/* SOUS-MENU */}
        {openSubmenu !== null &&
          ReactDOM.createPortal(
            <ul
              id="submenu-portal"
              className={styles.winMenu}
              style={{
                top: submenuPos.top,
                left: submenuPos.left,
                position: "absolute",
              }}
            >
              {actionsRight[openSubmenu].submenu.map((sub, sIdx) => (                
              <React.Fragment key={`frag-${sIdx}`}>
                <li
                  key={`item-${openSubmenu}-${sIdx}`}
                  className={styles.winItem}
                  onClick={(e) => {
                    sub.onClick(e);
                    setOpen(false);
                    setOpenSubmenu(null);
                  }}
                >
                  <span className={styles.winIcon}>{sub.icon}</span>
                  <span className={styles.winLabel}>{sub.label}</span>
                </li>
                 {/* Séparateur automatique sauf après le dernier */}
                 {sIdx < actionsRight[openSubmenu].submenu.length - 1 && (
                  <li className={styles.winSeparator}></li>
                )}
                </React.Fragment>
              ))}
            </ul>,
            document.body
          )}

    </>
  );
}

export default SearchActionsMenu;
